module.exports = __webpack_public_path__ + "static/wireframes-2-f26d1a2f4cfa69acbae8fdce33cc3103.jpg";